<div class="row">
    <div class="col-md-8">
        <div class="Markdown-post">
            <ng-container *ngIf="post$ | async as post">
                <div id="markdown-post" markdown [src]="post"></div>
            </ng-container>
          </div>
    </div>
    <div class="col-md-4">
        <h3 class="text-center">Recent Posts</h3>
        <app-entry-list-side-bar></app-entry-list-side-bar>
    </div>
</div>

